module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "500"
    },
    model: {
      value: (_vm.mostrar),
      callback: function($$v) {
        _vm.mostrar = $$v
      },
      expression: "mostrar"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline primary lighten-1 white--text"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [(this.resultado.totalImagens) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "subheading"
  }, [_vm._v("Quanditade de imagens do exame: " + _vm._s(_vm.resultado.totalImagens))])])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.mostraPorPagina) ? _c('v-select', {
    attrs: {
      "required": "",
      "label": "Imagens por Página",
      "items": _vm.quantidadesPorPagina,
      "item-text": "descricao",
      "item-value": "id",
      "hint": "Selecione a quantidade de imagens por página",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.porPagina),
      callback: function($$v) {
        _vm.porPagina = $$v
      },
      expression: "porPagina"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "label": "Padrão de seleção das imagens",
      "items": _vm.selecaoImages,
      "item-text": "descricao",
      "item-value": "id",
      "hint": "Selecione o padrão de seleção de imagens",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.pular),
      callback: function($$v) {
        _vm.pular = $$v
      },
      expression: "pular"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.fechar($event)
      }
    }
  }, [_vm._v("Fechar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.porPagina || !_vm.pular
    },
    nativeOn: {
      "click": function($event) {
        _vm.imprimir($event)
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("print")]), _vm._v(" Gerar Impressão")], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4324cf11"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImpressaoDialog.vue
// module id = 371
// module chunks = 1